import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';

import { ComponentSide, StubDistanceOption } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';
import { DistanceField } from '@paragon/material';

import { stub } from '../../../../store/actions/editorActions';
import { setTrussEditsPanel } from '../../../../store/slices/panelDataSlice';
import { useAppDispatch } from '../../../hooks';

export function StubTrussPanel() {
  const dispatch = useAppDispatch();

  const [sideToStub, setSideToStub] = useState<ComponentSide>('Left');
  const [stubDistanceOption, setStubDistanceOption] = useState('DistanceToStub' as StubDistanceOption);
  const [distance, setDistance] = useState(0);

  return (
    <PropertiesPanel title="Stub Truss" sx={{ paddingX: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl component="fieldset">
        <ToggleButtonGroup
          size="small"
          value={sideToStub}
          fullWidth
          exclusive
          onChange={(_, value: ComponentSide | null) => {
            if (value != null) setSideToStub(value);
          }}
          aria-label="Side To Stub"
        >
          <ToggleButton value="Left" aria-label="left aligned">
            Left Side
          </ToggleButton>
          <ToggleButton value="Right" aria-label="left aligned">
            Right Side
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <DistanceField label="Stub Distance" fullWidth value={distance} onSubmit={setDistance} />

      <FormControl component="fieldset" sx={{ display: 'flex', flexDirection: 'row' }}>
        <RadioGroup
          row
          aria-label="Stub Distance"
          name="stubDistanceOption1"
          value={stubDistanceOption}
          onChange={(event, value) => {
            setStubDistanceOption(value as StubDistanceOption);
          }}
        >
          <FormControlLabel
            id="stubDistanceOption"
            value="DistanceToStub"
            control={<Radio />}
            label="Distance To Stub"
          />
          <FormControlLabel id="stubDistanceOption" value="RemainingSpan" control={<Radio />} label="Remaining Span" />
        </RadioGroup>
      </FormControl>

      <Paper
        elevation={1}
        sx={{ marginX: -1, display: 'flex', gap: 1, justifyContent: 'flex-end', p: 1, borderRadius: 0 }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            dispatch(setTrussEditsPanel(null));
          }}
          aria-label="Close"
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            dispatch(setTrussEditsPanel(null));
            dispatch(stub(sideToStub, stubDistanceOption, distance));
          }}
        >
          Stub
        </Button>
      </Paper>
    </PropertiesPanel>
  );
}
